// Generated by CoffeeScript 2.4.1
(function() {
  var Weaver, WeaverModelQuery,
    splice = [].splice;

  Weaver = require('./Weaver');

  WeaverModelQuery = class WeaverModelQuery extends Weaver.Query {
    constructor(context = Weaver.currentModel(), target) {
      var constructorFunction;
      super(target);
      this.context = context || (function() {
        throw new Error('Please specify a model for the ModelQuery either by supplying an argument or setting Weaver.useModel(model)');
      })();
      this.model = context.model;
      this.keyMappingDisabled = false;
      // Define constructor function
      constructorFunction = (node, owner, key) => {
        var className, def, defs, i, len, modelKey, modelName, range, ranges, ref;
        defs = [];
        ref = node.relation(this.model.getMemberKey()).all();
        for (i = 0, len = ref.length; i < len; i++) {
          def = ref[i];
          if (this.model.classList[def.id()] != null) {
            defs.push(def.id());
          }
        }
        if (defs.length === 0) {
          return Weaver.Node;
        } else if (defs.length === 1) {
          return this.model.classList[defs[0]];
        // First order node from resultset, no incoming relation to help decide
        } else if (owner == null) {
          if (this.preferredConstructor == null) {
            console.info(`Could not choose contructing first order node between type ${JSON.stringify(defs)}`);
            return Weaver.DefinedNode;
          }
          return this.preferredConstructor;
        } else {
          if (!(owner instanceof Weaver.ModelClass)) {
            console.info(`Could not choose contructing node between type ${JSON.stringify(defs)}`);
            return Weaver.DefinedNode;
          }
          defs = typeof node.getDefinitions === "function" ? node.getDefinitions() : void 0;
          modelKey = owner._getModelKey(key, ...defs) || key;
          ranges = owner.getToRanges(modelKey, node);
          if (ranges.length < 1) {
            console.warn(`Could not find a range for constructing second order node between type ${JSON.stringify(defs)}`);
            return Weaver.Node;
          } else if (ranges.length > 1) {
            console.log(`Construct DefinedNode from ranges ${JSON.stringify(ranges)} for constructing second order node between type ${JSON.stringify(defs)}`);
            return Weaver.DefinedNode;
          } else {
            range = ranges[0];
            modelName = this.model.definition.name;
            className = range;
            if (range.indexOf(':') > -1) {
              [modelName, className] = range.split(':');
            }
            return this.model.modelMap[modelName][className];
          }
        }
      };
      this.setConstructorFunction(constructorFunction);
    }

    getNodeIdFromStringOrNode(node) {
      var err;
      try {
        return super.getNodeIdFromStringOrNode(node);
      } catch (error) {
        err = error;
        if (node.model != null) {
          return {
            id: `${node.model.definition.name}:${node.className}`,
            graph: node.model.getGraph()
          };
        } else {
          throw err;
        }
      }
    }

    class(modelClass) {
      this.preferredConstructor = modelClass;
      return this.hasRelationOut(this.model.getMemberKey(), new Weaver.ModelQuery(this.model).hasRecursiveRelationOut(this.model.getInheritKey(), Weaver.Node.getFromGraph(modelClass.classId(), modelClass.context.getGraph()), true));
    }

    disableKeyMapping() {
      this.keyMappingDisabled = true;
      return this;
    }

    // Key is composed of Class.modelAttribute
    _mapKeys(keys, source) {
      var candidate, classId, className, context, databaseKey, databaseKeys, definition, dotPath, i, key, len, modelClass, modelKey, modelTag, ref, ref1, ref2, ref3, ref4, ref5, ref6;
      if (this.keyMappingDisabled) {
        return keys;
      }
      databaseKeys = [];
      for (i = 0, len = keys.length; i < len; i++) {
        key = keys[i];
        if ([this.model.getMemberKey(), this.model.getInheritKey(), '*'].includes(key) || key.indexOf('.') === -1) {
          databaseKeys.push(key);
        } else {
          ref = key.split('.'), [...dotPath] = ref, [modelKey] = splice.call(dotPath, -1);
          // Wildcard class selector
          if (dotPath.join() === '*') {
            ref1 = this.model.classList;
            // Scan all classes and add all mapping hits
            for (classId in ref1) {
              modelClass = ref1[classId];
              definition = modelClass.totalClassDefinition;
              databaseKey = (ref2 = definition[source]) != null ? (ref3 = ref2[modelKey]) != null ? ref3.key : void 0 : void 0;
              if (databaseKey != null) {
                databaseKeys.push(databaseKey);
              }
            }
          } else {
            // Proper dot path
            classId = this.context.getNodeNameByKey(dotPath.join('.'));
            modelClass = this.model.classList[classId];
            if (modelClass == null) {
              ref4 = this.model.contextMap;
              // Try all namespaces, throw Error on name collision
              for (modelTag in ref4) {
                context = ref4[modelTag];
                className = classId.split(':').pop();
                candidate = `${context.definition.name}:${className}`;
                if (this.model.classList[candidate] != null) {
                  if (modelClass != null) {
                    throw new Error(`Multiple models have a class named ${className}, please specify context`);
                  }
                  modelClass = this.model.classList[candidate];
                }
              }
            }
            if (modelClass == null) {
              throw new Error(`Could not locate class for ${key}`);
            }
            definition = modelClass.totalClassDefinition;
            databaseKeys.push(((ref5 = definition[source]) != null ? (ref6 = ref5[modelKey]) != null ? ref6.key : void 0 : void 0) || modelKey);
          }
        }
      }
      return databaseKeys;
    }

    _mapKey(key, source) {
      return this._mapKeys([key], source)[0];
    }

    _addAttributeCondition(key, condition, value) {
      return super._addAttributeCondition(this._mapKey(key, "attributes"), condition, value);
    }

    _addRelationCondition(key, condition, value) {
      return super._addRelationCondition(this._mapKey(key, "relations"), condition, value);
    }

    _addRecursiveCondition(op, relation, node, includeSelf) {
      return super._addRecursiveCondition(op, this._mapKey(relation, "relations"), node, includeSelf);
    }

    equalTo(key, value) {
      return super.equalTo(this._mapKey(key, "attributes"), value);
    }

    order(keys, ascending) {
      return super.order(this._mapKeys(keys, "attributes"), ascending);
    }

    select(...keys) {
      var i, key, len, ref;
      ref = this._mapKeys(keys, "attributes");
      for (i = 0, len = ref.length; i < len; i++) {
        key = ref[i];
        super.select(key);
      }
      return this;
    }

    selectOut(...keys) {
      // Note that calling selectOut(1, 2) differs from calling selectOut(1)
      // selectOut(2). Arrayity matters
      super.selectOut(...this._mapKeys(keys, "relations"));
      return this;
    }

    selectIn(...keys) {
      super.selectIn(...this._mapKeys(keys, "relations"));
      return this;
    }

    nodeSelectOut(...args) {
      Weaver.Query.prototype.selectOut.call(this, ...args);
      return this;
    }

    selectRecursiveOut(...keys) {
      super.selectRecursiveOut(...this._mapKeys(keys, "relations"));
      return this;
    }

    selectRecursiveIn(...keys) {
      super.selectRecursiveIn(...this._mapKeys(keys, "relations"));
      return this;
    }

    selectRelations(...keys) {
      super.selectRelations(...this._mapKeys(keys, "relations"), this.model.definition['member']);
      return this;
    }

    alwaysLoadAttributes(...keys) {
      super.alwaysLoadAttributes(...this._mapKeys(keys, "attributes"));
      return this;
    }

    alwaysLoadRelations(...keys) {
      super.alwaysLoadRelations(...this._mapKeys(keys, "relations"));
      return this;
    }

    find(preferredConstructor) {
      this.preferredConstructor = preferredConstructor;
      // Always get the member relation to map to the correct modelclass
      this.alwaysLoadRelations(this.model.getMemberKey());
      return super.find();
    }

    destruct() {
      delete this.model;
      delete this.context;
      delete this.target;
      delete this.preferredConstructor;
      delete this.constructorFunction;
      return this;
    }

  };

  module.exports = WeaverModelQuery;

}).call(this);
